import {
  getLeaveTypes as getLeaveTypesService,
  createLeaveType as createLeaveTypeService,
  updateLeaveTypeStatus as updateLeaveTypeStatusService,
  updateLeaveType as updateLeaveTypeService,
  deleteLeaveType as deleteLeaveTypeService,
} from "services/company/leaveManagement/leaveType/leaveTypeService";
import {
  getLeaveTypesStart,
  getLeaveTypesSuccess,
  getLeaveTypesFailure,
  createLeaveTypeStart,
  createLeaveTypeSuccess,
  createLeaveTypeFailure,
  updateLeaveTypeStart,
  updateLeaveTypeSuccess,
  updateLeaveTypeFailure,
  deleteLeaveTypeStart,
  deleteLeaveTypeSuccess,
  deleteLeaveTypeFailure,
  updateLeaveTypeStatusStart,
  updateLeaveTypeStatusSuccess,
  updateLeaveTypeStatusFailure,
} from "./leaveTypeSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all leave types
export const fetchLeaveTypes = () => async (dispatch) => {
  try {
    dispatch(getLeaveTypesStart());
    const response = await getLeaveTypesService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getLeaveTypesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch leave types";
      dispatch(getLeaveTypesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch leave types error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch leave types";
    dispatch(getLeaveTypesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new leave type
export const createNewLeaveType = (leaveTypeData) => async (dispatch) => {
  try {
    dispatch(createLeaveTypeStart());
    const response = await createLeaveTypeService(leaveTypeData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createLeaveTypeSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Leave type created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create leave type";
      dispatch(createLeaveTypeFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create leave type error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create leave type";
    dispatch(createLeaveTypeFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update status togglee
export const toggleLeaveTypeStatus =
  (leaveTypeId, currentStatus) => async (dispatch) => {
    try {
      dispatch(updateLeaveTypeStatusStart());
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      const response = await updateLeaveTypeStatusService(
        leaveTypeId,
        newStatus,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          updateLeaveTypeStatusSuccess({ id: leaveTypeId, status: newStatus }),
        );
        showSuccessToast(
          response?.meta?.message ||
            `Leave type ${
              newStatus === "active" ? "activated" : "inactivated"
            } successfully!`,
        );
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update leave type status";
        dispatch(updateLeaveTypeStatusFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update leave type status error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update leave type status";
      dispatch(updateLeaveTypeStatusFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
// Update a leave type
export const updateExistingLeaveType =
  (leaveTypeId, leaveTypeData) => async (dispatch) => {
    try {
      dispatch(updateLeaveTypeStart());
      const response = await updateLeaveTypeService(leaveTypeId, leaveTypeData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateLeaveTypeSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Leave type updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update leave type";
        dispatch(updateLeaveTypeFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update leave type error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update leave type";
      dispatch(updateLeaveTypeFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Delete a leave type
export const deleteExistingLeaveType = (leaveTypeId) => async (dispatch) => {
  try {
    dispatch(deleteLeaveTypeStart());
    const response = await deleteLeaveTypeService(leaveTypeId);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(deleteLeaveTypeSuccess(leaveTypeId));
      showSuccessToast(
        response?.meta?.message || "Leave type inactivated successfully!",
      );
      return { success: true };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to inactivate leave type";
      dispatch(deleteLeaveTypeFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Delete leave type error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to inactivate leave type";
    dispatch(deleteLeaveTypeFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
